import { Component, Input, OnInit } from '@angular/core';
import { EstensaSettingsType } from '../search-page/search-param.model';
import { ISelectionButtonMetadata } from '../search-page/search-result/search-result.component';

@Component({
    selector: 'se-search-footer-toolbar',
    templateUrl: './se-search-footer-toolbar.component.html',
    styleUrls: ['./se-search-footer-toolbar.component.scss'],
    standalone: false
})
export class SeSearchFooterToolbarComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

    protected readonly EstensaSettingsType = EstensaSettingsType;
    @Input()
    selectionMetaData: ISelectionButtonMetadata[] = [];
    @Input()
    items: any[] = [];
    @Input()
    unselectAllBtnClick!: () => void;
    @Input()
    selectionBtnClick!: (data: ISelectionButtonMetadata) => void;
    @Input()
    removeSelectionBtnClick!: ($event: MouseEvent, data: ISelectionButtonMetadata) => void;

}
